/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddHotHoldingReadingCommandControllerAddReading201,
  AddHotHoldingReadingDto,
  GetHotHoldingBoardQueryControllerGetBoardParams,
  HotHoldingBoardResponseDto,
  LogHotHoldingDeliveryCommandControllerLogDelivery201,
  LogHotHoldingDeliveryDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Log a hot holding meal and record its first (delivery) reading
 */
export const logHotHoldingDeliveryCommandControllerLogDelivery = (
  nurseryId: string,
  logHotHoldingDeliveryDto: LogHotHoldingDeliveryDto,
  signal?: AbortSignal,
) => {
  return axiosClient<LogHotHoldingDeliveryCommandControllerLogDelivery201>({
    url: `/v1/nurseries/${nurseryId}/hot-holding-meals`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: logHotHoldingDeliveryDto,
    signal,
  });
};

export const getLogHotHoldingDeliveryCommandControllerLogDeliveryMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof logHotHoldingDeliveryCommandControllerLogDelivery>
      >,
      TError,
      { nurseryId: string; data: LogHotHoldingDeliveryDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof logHotHoldingDeliveryCommandControllerLogDelivery>
    >,
    TError,
    { nurseryId: string; data: LogHotHoldingDeliveryDto },
    TContext
  > => {
    const mutationKey = ["logHotHoldingDeliveryCommandControllerLogDelivery"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof logHotHoldingDeliveryCommandControllerLogDelivery>
      >,
      { nurseryId: string; data: LogHotHoldingDeliveryDto }
    > = (props) => {
      const { nurseryId, data } = props ?? {};

      return logHotHoldingDeliveryCommandControllerLogDelivery(nurseryId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type LogHotHoldingDeliveryCommandControllerLogDeliveryMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof logHotHoldingDeliveryCommandControllerLogDelivery>
    >
  >;
export type LogHotHoldingDeliveryCommandControllerLogDeliveryMutationBody =
  LogHotHoldingDeliveryDto;
export type LogHotHoldingDeliveryCommandControllerLogDeliveryMutationError =
  void;

/**
 * @summary Log a hot holding meal and record its first (delivery) reading
 */
export const useLogHotHoldingDeliveryCommandControllerLogDelivery = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof logHotHoldingDeliveryCommandControllerLogDelivery>
      >,
      TError,
      { nurseryId: string; data: LogHotHoldingDeliveryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof logHotHoldingDeliveryCommandControllerLogDelivery>>,
  TError,
  { nurseryId: string; data: LogHotHoldingDeliveryDto },
  TContext
> => {
  return useMutation(
    getLogHotHoldingDeliveryCommandControllerLogDeliveryMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * @summary Add a reading (e.g. service) to an existing hot holding meal
 */
export const addHotHoldingReadingCommandControllerAddReading = (
  mealId: string,
  addHotHoldingReadingDto: AddHotHoldingReadingDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AddHotHoldingReadingCommandControllerAddReading201>({
    url: `/v1/hot-holding-meals/${mealId}/readings`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addHotHoldingReadingDto,
    signal,
  });
};

export const getAddHotHoldingReadingCommandControllerAddReadingMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addHotHoldingReadingCommandControllerAddReading>
      >,
      TError,
      { mealId: string; data: AddHotHoldingReadingDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof addHotHoldingReadingCommandControllerAddReading>>,
    TError,
    { mealId: string; data: AddHotHoldingReadingDto },
    TContext
  > => {
    const mutationKey = ["addHotHoldingReadingCommandControllerAddReading"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addHotHoldingReadingCommandControllerAddReading>
      >,
      { mealId: string; data: AddHotHoldingReadingDto }
    > = (props) => {
      const { mealId, data } = props ?? {};

      return addHotHoldingReadingCommandControllerAddReading(mealId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddHotHoldingReadingCommandControllerAddReadingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addHotHoldingReadingCommandControllerAddReading>>
  >;
export type AddHotHoldingReadingCommandControllerAddReadingMutationBody =
  AddHotHoldingReadingDto;
export type AddHotHoldingReadingCommandControllerAddReadingMutationError = void;

/**
 * @summary Add a reading (e.g. service) to an existing hot holding meal
 */
export const useAddHotHoldingReadingCommandControllerAddReading = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addHotHoldingReadingCommandControllerAddReading>
      >,
      TError,
      { mealId: string; data: AddHotHoldingReadingDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addHotHoldingReadingCommandControllerAddReading>>,
  TError,
  { mealId: string; data: AddHotHoldingReadingDto },
  TContext
> => {
  return useMutation(
    getAddHotHoldingReadingCommandControllerAddReadingMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Hot holding board for a nursery on a given day (defaults to today), grouped into two lanes
 */
export const getHotHoldingBoardQueryControllerGetBoard = (
  nurseryId: string,
  params?: GetHotHoldingBoardQueryControllerGetBoardParams,
  signal?: AbortSignal,
) => {
  return axiosClient<HotHoldingBoardResponseDto>({
    url: `/v1/nurseries/${nurseryId}/hot-holding-meals/board`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetHotHoldingBoardQueryControllerGetBoardQueryKey = (
  nurseryId: string,
  params?: GetHotHoldingBoardQueryControllerGetBoardParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/hot-holding-meals/board`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetHotHoldingBoardQueryControllerGetBoardQueryOptions = <
  TData = Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
  TError = void,
>(
  nurseryId: string,
  params?: GetHotHoldingBoardQueryControllerGetBoardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetHotHoldingBoardQueryControllerGetBoardQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>
  > = ({ signal }) =>
    getHotHoldingBoardQueryControllerGetBoard(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHotHoldingBoardQueryControllerGetBoardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>
>;
export type GetHotHoldingBoardQueryControllerGetBoardQueryError = void;

export function useGetHotHoldingBoardQueryControllerGetBoard<
  TData = Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | GetHotHoldingBoardQueryControllerGetBoardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
          TError,
          Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHotHoldingBoardQueryControllerGetBoard<
  TData = Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
  TError = void,
>(
  nurseryId: string,
  params?: GetHotHoldingBoardQueryControllerGetBoardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
          TError,
          Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetHotHoldingBoardQueryControllerGetBoard<
  TData = Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
  TError = void,
>(
  nurseryId: string,
  params?: GetHotHoldingBoardQueryControllerGetBoardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Hot holding board for a nursery on a given day (defaults to today), grouped into two lanes
 */

export function useGetHotHoldingBoardQueryControllerGetBoard<
  TData = Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
  TError = void,
>(
  nurseryId: string,
  params?: GetHotHoldingBoardQueryControllerGetBoardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getHotHoldingBoardQueryControllerGetBoard>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetHotHoldingBoardQueryControllerGetBoardQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
